import * as React from 'react';
import { Card, CardActions, CardContent, CardMedia, Button, Typography }  from '@mui/material';
import { Tilt } from 'react-tilt';

export default function CardProduct(props) {
  return (
    <Tilt options={{ reverse: false, max: 35, perspective: 1e3, easing: "cubic-bezier(.03,.98,.52,.99)", scale: "1", speed: "1000", transition: true, axis: null, reset: true}}> 
      <Card sx={{ minWidth: 300 }}>
        <CardMedia
          sx={{ height: 300 }}
          component="img"
          image={'/images/' + props.img}
          alt={props.description}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {props.title}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {props.description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size='small' href={props.video} target='_blank'>+Informacion</Button>       
        </CardActions>
      </Card>         
    </Tilt>
  );
}
